import { getEnvVar } from "@/utils/util";
import React from "react";

interface EnvironmentBadgeProps {
  className?: string;
}

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({ className = "" }) => {
  const environment = getEnvVar("APP_ENV") || "local";

  // Don't show badge in production
  if (environment === "prod") {
    return null;
  }

  const getEnvironmentConfig = () => {
    switch (environment) {
      case "local":
        return {
          label: "LOCALHOST",
          bgColor: "bg-blue-500",
          textColor: "text-white",
          borderColor: "border-blue-600",
        };
      case "dev":
      case "development":
        return {
          label: "DEVELOPMENT",
          bgColor: "bg-orange-500",
          textColor: "text-white",
          borderColor: "border-orange-600",
        };
      default:
        return {
          label: environment.toUpperCase(),
          bgColor: "bg-gray-500",
          textColor: "text-white",
          borderColor: "border-gray-600",
        };
    }
  };

  const config = getEnvironmentConfig();

  return (
    <div
      className={`
        fixed top-4 left-1/2 transform -translate-x-1/2 z-50
        px-4 py-1 
        text-sm font-bold
        rounded-md border-2
        shadow-lg
        min-w-[120px]
        text-center
        ${config.bgColor} 
        ${config.textColor} 
        ${config.borderColor}
        ${className}
      `}
      title={`Environment: ${environment}`}
    >
      {config.label}
    </div>
  );
};

export default EnvironmentBadge;
